import Rest from '@/services/Rest'

export default class UtilitiesService extends Rest {

  /**
   * @type {String}
   */
  static resource = '/utilities';


}
